 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5","EmployeeCharities":"EmployeeCharities","admin-overview~company-reporting-page~reporting-page":"admin-overview~company-reporting-page~reporting-page","admin-overview":"admin-overview","company-reporting-page":"company-reporting-page","reporting-page":"reporting-page","approvals":"approvals","business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990":"business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990","business-employees-page":"business-employees-page","charity-donations":"charity-donations","charity-event-detail":"charity-event-detail","communication":"communication","dialog-campaign":"dialog-campaign","donations":"donations","employee":"employee","employee-profile":"employee-profile","fundraising-needs":"fundraising-needs","manage-my-team":"manage-my-team","member-donations":"member-donations","member-overview":"member-overview","opportunities":"opportunities","opportunity-details":"opportunity-details","reporting-maps":"reporting-maps","campaign":"campaign","charity":"charity","charity-events":"charity-events","charity-involvement-donations":"charity-involvement-donations","charity-involvement-volunteering":"charity-involvement-volunteering","charity-profile~dashboard":"charity-profile~dashboard","charity-profile":"charity-profile","dashboard":"dashboard","days-off-requests":"days-off-requests","donations-summary":"donations-summary","employee-overview":"employee-overview","import-voting":"import-voting","member-charities":"member-charities","member-voting":"member-voting","members~users":"members~users","members":"members","users":"users","my-voting":"my-voting","partner-charities":"partner-charities","voters-guide":"voters-guide","profile-employee":"profile-employee","edit-page~general-settings-page":"edit-page~general-settings-page","edit-page":"edit-page","general-settings-page":"general-settings-page","admin-page":"admin-page","registration-page":"registration-page","confirmation-account~login~new-password~reset-password":"confirmation-account~login~new-password~reset-password","confirmation-account":"confirmation-account","login":"login","new-password":"new-password","reset-password":"reset-password","error-410":"error-410","faqs":"faqs","voters-guide-employee":"voters-guide-employee"}[chunkId]||chunkId) + "." + {"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d":"59d95a52","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582":"5c9d2961","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5":"13373691","EmployeeCharities":"fee607b9","admin-overview~company-reporting-page~reporting-page":"e1506751","admin-overview":"e7cfd65a","company-reporting-page":"956ed7a0","reporting-page":"091e3baf","approvals":"090da76f","business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990":"b8a7e065","business-employees-page":"44e93dfd","charity-donations":"a6855ca9","charity-event-detail":"2462315c","communication":"99c15648","dialog-campaign":"2cfde2b7","donations":"b49dbf39","employee":"46d88687","employee-profile":"ceb23da0","fundraising-needs":"3f1a1892","manage-my-team":"19dbabbd","member-donations":"934a7dcc","member-overview":"0753d352","opportunities":"6fd16418","opportunity-details":"a4c6f2f2","reporting-maps":"86fb9094","campaign":"d065e8d6","charity":"01e04f2d","charity-events":"2f4940b3","charity-involvement-donations":"668cbabb","charity-involvement-volunteering":"b6261603","charity-profile~dashboard":"872c0306","charity-profile":"2d23c083","dashboard":"fd649053","days-off-requests":"54fbcd71","donations-summary":"1a55e17f","employee-overview":"1f4945dc","import-voting":"7e3ccf40","member-charities":"392f40a1","member-voting":"74e59c34","members~users":"5424a502","members":"22644b66","users":"33925fbb","my-voting":"b618c595","partner-charities":"1f2524cd","voters-guide":"c6b06778","profile-employee":"f4dc935b","edit-page~general-settings-page":"5ec4f179","edit-page":"16661506","general-settings-page":"7d945aea","admin-page":"b16e497a","registration-page":"a89dcd71","confirmation-account~login~new-password~reset-password":"37bad880","confirmation-account":"7e0f3b46","login":"ce182719","new-password":"64de7aea","reset-password":"e72829b5","error-410":"dbba5806","faqs":"a51f3777","voters-guide-employee":"76527b13"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d":1,"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582":1,"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5":1,"EmployeeCharities":1,"admin-overview~company-reporting-page~reporting-page":1,"admin-overview":1,"company-reporting-page":1,"reporting-page":1,"approvals":1,"business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990":1,"business-employees-page":1,"charity-donations":1,"charity-event-detail":1,"communication":1,"dialog-campaign":1,"donations":1,"employee":1,"employee-profile":1,"fundraising-needs":1,"manage-my-team":1,"member-donations":1,"member-overview":1,"opportunities":1,"opportunity-details":1,"reporting-maps":1,"campaign":1,"charity":1,"charity-events":1,"charity-involvement-volunteering":1,"charity-profile~dashboard":1,"charity-profile":1,"dashboard":1,"days-off-requests":1,"donations-summary":1,"employee-overview":1,"import-voting":1,"member-charities":1,"member-voting":1,"members~users":1,"members":1,"my-voting":1,"partner-charities":1,"voters-guide":1,"profile-employee":1,"edit-page~general-settings-page":1,"edit-page":1,"general-settings-page":1,"admin-page":1,"registration-page":1,"confirmation-account~login~new-password~reset-password":1,"login":1,"new-password":1,"error-410":1,"faqs":1,"voters-guide-employee":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5":"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5","EmployeeCharities":"EmployeeCharities","admin-overview~company-reporting-page~reporting-page":"admin-overview~company-reporting-page~reporting-page","admin-overview":"admin-overview","company-reporting-page":"company-reporting-page","reporting-page":"reporting-page","approvals":"approvals","business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990":"business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990","business-employees-page":"business-employees-page","charity-donations":"charity-donations","charity-event-detail":"charity-event-detail","communication":"communication","dialog-campaign":"dialog-campaign","donations":"donations","employee":"employee","employee-profile":"employee-profile","fundraising-needs":"fundraising-needs","manage-my-team":"manage-my-team","member-donations":"member-donations","member-overview":"member-overview","opportunities":"opportunities","opportunity-details":"opportunity-details","reporting-maps":"reporting-maps","campaign":"campaign","charity":"charity","charity-events":"charity-events","charity-involvement-donations":"charity-involvement-donations","charity-involvement-volunteering":"charity-involvement-volunteering","charity-profile~dashboard":"charity-profile~dashboard","charity-profile":"charity-profile","dashboard":"dashboard","days-off-requests":"days-off-requests","donations-summary":"donations-summary","employee-overview":"employee-overview","import-voting":"import-voting","member-charities":"member-charities","member-voting":"member-voting","members~users":"members~users","members":"members","users":"users","my-voting":"my-voting","partner-charities":"partner-charities","voters-guide":"voters-guide","profile-employee":"profile-employee","edit-page~general-settings-page":"edit-page~general-settings-page","edit-page":"edit-page","general-settings-page":"general-settings-page","admin-page":"admin-page","registration-page":"registration-page","confirmation-account~login~new-password~reset-password":"confirmation-account~login~new-password~reset-password","confirmation-account":"confirmation-account","login":"login","new-password":"new-password","reset-password":"reset-password","error-410":"error-410","faqs":"faqs","voters-guide-employee":"voters-guide-employee"}[chunkId]||chunkId) + "." + {"EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~0356772d":"8476606b","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~e21bb582":"41c2ce01","EmployeeCharities~admin-overview~approvals~business-employees-page~campaign~charity~charity-donation~cf7c3cc5":"eff04524","EmployeeCharities":"37932384","admin-overview~company-reporting-page~reporting-page":"66d3982c","admin-overview":"1d5cf769","company-reporting-page":"15e9cd08","reporting-page":"ba9cb3c9","approvals":"48fbf4d1","business-employees-page~charity-donations~charity-event-detail~communication~dialog-campaign~donatio~3992e990":"bf159090","business-employees-page":"4b40625a","charity-donations":"a7dc0bb8","charity-event-detail":"26ccc897","communication":"b01a5955","dialog-campaign":"563a4d06","donations":"72ba3d63","employee":"682a1191","employee-profile":"a12a98f9","fundraising-needs":"93d4adf6","manage-my-team":"647c1d3e","member-donations":"5b352af3","member-overview":"4af5f7a9","opportunities":"3c067b24","opportunity-details":"68fdf7eb","reporting-maps":"d5c2d00e","campaign":"d27d321f","charity":"ff510433","charity-events":"71645564","charity-involvement-donations":"31d6cfe0","charity-involvement-volunteering":"e4d5d63f","charity-profile~dashboard":"652a045d","charity-profile":"fdacfe40","dashboard":"43c5a4d7","days-off-requests":"de7d55f2","donations-summary":"c1dd94e3","employee-overview":"94f0cdb2","import-voting":"976f821b","member-charities":"e710bfa2","member-voting":"399a28f3","members~users":"b97d2449","members":"7cbaddde","users":"31d6cfe0","my-voting":"36df54c0","partner-charities":"6eb78365","voters-guide":"a6e0df35","profile-employee":"625be085","edit-page~general-settings-page":"0cb9b089","edit-page":"000d843f","general-settings-page":"09ce8c0f","admin-page":"29de78b2","registration-page":"ac0c0338","confirmation-account~login~new-password~reset-password":"6183f034","confirmation-account":"31d6cfe0","login":"0d0a3844","new-password":"ecf8f88c","reset-password":"31d6cfe0","error-410":"9e677798","faqs":"20b9e1da","voters-guide-employee":"acc3d3cc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
